import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const StoreIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    {...props}>
    <Path
      fill="#8697AB"
      d="M9.334 14.667a1 1 0 0 1 1 1v2.666a1 1 0 1 1-2 0v-2.666a1 1 0 0 1 1-1ZM15.667 15.667a1 1 0 1 0-2 0v2.666a1 1 0 1 0 2 0v-2.666Z"
    />
    <Path
      fill="#8697AB"
      fillRule="evenodd"
      d="M8.866 1.5a1 1 0 0 0-1.732-1L4.467 5.119c-.04.069-.07.141-.092.214H4a3.667 3.667 0 0 0-2.318 6.508l.889 6.113.596 2.79a4.065 4.065 0 0 0 3.415 3.178c3.595.5 7.241.5 10.836 0a4.065 4.065 0 0 0 3.416-3.177l.596-2.791.889-6.113A3.667 3.667 0 0 0 20 5.334h-.375a1.01 1.01 0 0 0-.092-.215L16.866.5a1 1 0 0 0-1.732 1l2.213 3.833H6.653L8.866 1.5Zm11.312 11.162a3.75 3.75 0 0 1-.178.005H4c-.06 0-.119-.002-.178-.005l.719 4.939.581 2.726c.182.85.875 1.495 1.736 1.614a37.31 37.31 0 0 0 10.285 0 2.065 2.065 0 0 0 1.735-1.614l.582-2.726.718-4.938ZM2.333 9c0-.92.747-1.667 1.667-1.667h16a1.667 1.667 0 0 1 0 3.334H4c-.92 0-1.667-.746-1.667-1.667Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default StoreIcon;
